const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForward5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    style: {
      fill: "none",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.03,14.05c0,3.88-3.15,7.03-7.03,7.03s-7.03-3.15-7.03-7.03,3.15-7.03,7.03-7.03v4.68l5.85-5.85L12,0v4.68c-5.18,0-9.37,4.19-9.37,9.37s4.19,9.37,9.37,9.37,9.37-4.19,9.37-9.37h-2.34Z",
    style: {
      fill: "currentColor",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.59,13.61h-2.23l-.22,1.5c.13-.02.26-.04.48-.04.45,0,.9.1,1.26.32.46.26.84.76.84,1.5,0,1.14-.91,2-2.18,2-.64,0-1.18-.18-1.46-.36l.2-.6c.24.14.72.32,1.25.32.75,0,1.39-.49,1.39-1.27,0-.76-.51-1.3-1.68-1.3-.33,0-.59.04-.81.06l.38-2.81h2.8v.67Z",
    style: {
      fill: "currentColor",
      strokeWidth: 0
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForward5);
export default __webpack_public_path__ + "static/media/forward5.ed8fc1cf7c9fc60184777865d8d9248c.svg";
export { ForwardRef as ReactComponent };